module.exports = __webpack_public_path__ + "media/images/photo_ios_payment_instruction-10524b79fef720f50c87e84d82780d59.png";